import { useCallback, useEffect, useRef } from "react";
import { Image } from "../shared/models";

interface Props {
  images?: Image[];
}
function Gallery({ images }: Props) {
  const lightGallery = useRef<any>(null);

  const onInit = useCallback((detail: any) => {
    if (detail) {
      lightGallery.current = detail.instance;
    }
  }, []);

  const getItems = useCallback(() => {
    return (
      images &&
      images.map((item) => {
        return (
          <div key={item.id} className="col-md-4 mb-4">
            <img alt="Objava" src={item.file_url} />
          </div>
        );
      })
    );
  }, [images]);

  return (
    <div className="gallery">
      <div className="row">{getItems()}</div>
    </div>
  );
}

export default Gallery;
